import React from "react";
import util from 'lodash/util';

import withAuthorization from '../Session/withAuthorization';
import CaazamLibrary from '../CaazamModel/CaazamLibrary';
import CaazamUser from '../CaazamModel/CaazamUser';
import MediaBrowser from '../Components/MediaBrowser';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import withWidth from '@material-ui/core/withWidth';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';

import { withStyles } from '@material-ui/core/styles';

import { Link } from 'react-router-dom';
import * as routes from '../Constants/routes';
import GoogleAnalytics from '../Components/GoogleAnalytics';

const styles = theme => ({
  root: {
    paddingTop: theme.spacing.unit * 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },

  gridList: {
    height: 'auto',
    width: '100%',
    overflowY: 'auto',
  },

  noPhotosText: {
    color: theme.palette.primary.dark,
  },
});

class Home extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      mediaList: [],
      loading: true,
      browserOpen: false,
    }

    const { authUser } = this.props; //passed from WithAuthorization HOC
    this.library = new CaazamLibrary(authUser.uid);
    this.storageKey = 'caazam.' + authUser.uid + '.mediaList';
    this.browserStartIndex = null;
    
    //thease are for controlling scorlling and auto loading more photos
    this.nextMediaPage = null;
    this.handleScroll = this.handleScroll.bind(this);
  }

  isValidImage(image) {
    return !!image.publicUrls && image.status !== 'deleted';
  }

  addImagesToGrid(images, newer = true) {
    let filteredMediaList = images.filter(image => this.isValidImage(image)) // filter out any media that doesn't have publicUrls or were deleted
    let newMediaList = newer ? filteredMediaList.concat(this.state.mediaList) : this.state.mediaList.concat(filteredMediaList);
    this.setState({ mediaList: newMediaList, loading: false });
  }

  componentWillMount() {

    this.library.getMedia().then(result => {
      console.log(`getMedia done with ${result.entries.length} new results, next=${!!result.nextPage}`);
      let fetchedMedia = result.entries;
      var lastestMedia = fetchedMedia[0];

      // subscribe to notifications on new media being added (has to be newer than existing)
      this.library.subscribeToMediaAdd(newMedia => {
        console.log(`mediaAdded: uuid ${newMedia.mediaUuid}`);
        this.addImagesToGrid([newMedia]);
      }, lastestMedia);

      this.library.subscribeToMediaDeleted(mediaDeleted => {
        let deletedIndex = this.state.mediaList.findIndex(element => element.mediaUuid === mediaDeleted);
        if (deletedIndex >= 0) {
          console.log(`mediaDeleted: index ${deletedIndex} uuid ${mediaDeleted}`);
          let newMediaList = this.state.mediaList;
          let isBroswerOpen = this.state.browserOpen;
          newMediaList.splice(deletedIndex, 1);
          this.setState({ mediaList: newMediaList, browserOpen: (isBroswerOpen && newMediaList.length !== 0) });
        } else {
          console.warn('recevied delete notification for unknown media', mediaDeleted);
        }
      });

      this.library.subscribeToMediaChanged(changed => {
        let changeIndex = this.state.mediaList.findIndex(element => element.mediaUuid === changed.mediaUuid);
        if (changeIndex >= 0) {
          console.log(`mediaChanged: index ${changeIndex} uuid ${changed.mediaUuid}`);
          let newMediaList = this.state.mediaList;
          newMediaList[changeIndex] = changed;
          this.setState({ mediaList: newMediaList });
        } else {
          console.warn('recevied change notification for unknown media', changed.mediaUuid);
        }
      });

      this.addImagesToGrid(fetchedMedia);
      this.nextMediaPage = result.nextPage;
      this.handleScroll();
    }).catch(error => {
      console.error('componentWillMount',error);
    });

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    this.library.cancelAllSubscriptions();
    window.removeEventListener('scroll', this.handleScroll);
  }
  
  render() {
    const { classes, width, authUser } = this.props;
    const { loading, mediaList } = this.state;

    console.log('Home:render',mediaList.length);
    const isValidProfileImage = (new CaazamUser(authUser)).isValidProfileImage();

    // dynamic number of columns and cell height absed on width of screen
    var numOfColumns = 4;
    switch (width) {
      case 'xs':
        break;
      case 'sm':
        numOfColumns = 6;
        break;
      case 'md':
        numOfColumns = 8;
        break;
      default:
        numOfColumns = 10;
    }
    let cellHeight = window.innerWidth / numOfColumns;

    return (      
      <div className={classes.root}>
        <Grid container spacing={8} align="center">
          <Grid item xs={12}>
            <Typography variant="title" paragraph >
              Photos of Me
            </Typography>
          </Grid>
          {loading && <Grid item xs={12}><CircularProgress className={classes.progress} /></Grid>}
          {!loading && mediaList.length === 0 &&
            <Grid item xs={12}>
              <Typography className={classes.noPhotosText} variant='body2' gutterBottom>
                All the photos you've been Caazamed! in will appear here.
            </Typography>
            {!isValidProfileImage && <Typography className={classes.noPhotosText} variant='body2' component={Link} to={routes.PROFILE}>
                Take a selfie and Caazam! will find you in photos
            </Typography>}
            </Grid>
          }
        </Grid>
        <GridList cellHeight={cellHeight} className={classes.gridList} cols={numOfColumns}>

          {mediaList.map((media,index) => (
            <GridListTile key={media.mediaUuid} cols={1} onClick={(e) => this.handleOpenBrowser(e,index)}>
              <img src={media.publicUrls.size_thumb.url} alt={media.mediaUuid} />
            </GridListTile>
          ))}
        </GridList>
        <Modal 
          theme={this.props.theme}
          open={this.state.browserOpen}
          onClose={this.handleCloseBrowser}
        >
          <MediaBrowser
            mediaList={mediaList}
            selfUuid = {authUser.uid}
            indexToStart={this.browserStartIndex}
            onCloseBrowser={this.handleCloseBrowser}
            onDelete={this.handleDeleteMedia} 
            onFavStatusChange={this.handleFavStatusChange}/>
        </Modal>

      </div>
    );
  }

  handleScroll() {   
    let scrollCondition = (window.innerHeight + window.scrollY) >= document.body.offsetHeight * 0.8;
    if (scrollCondition && this.nextMediaPage) {
      console.log('Loading next page of posts.');
      this.nextMediaPage().then(result => {
        console.log(`Loading done with ${result.entries.length} new results, next=${!!result.nextPage}`);
        let fetchedMedia = result.entries;
        let newer = false;
        this.addImagesToGrid(fetchedMedia,newer);
        this.nextMediaPage = result.nextPage;
      }).catch(error => {
        console.error('handleScroll', error);
      });
    }
  }

  handleOpenBrowser = (event,index) => {
    GoogleAnalytics.modalView('home/photoBroswer');
    this.browserStartIndex = index;
    this.setState({browserOpen: true});
  }

  handleCloseBrowser = () => {
    this.setState({browserOpen: false});
  }

  handleDeleteMedia = (mediaIndex) => {
    let uuid = this.state.mediaList[mediaIndex].mediaUuid;
    console.log(`media in index ${mediaIndex} has been deleted ${uuid}`);
    if (mediaIndex === this.state.mediaList.length - 1) {
      //this.setState({browserOpen: false});
    }
    this.library.deleteMedia(uuid);
  }

  handleFavStatusChange = (mediaIndex, favStatus) => {
    let uuid = this.state.mediaList[mediaIndex].mediaUuid;
    console.log(`media in index ${mediaIndex} ${uuid} fav status set to ${favStatus}`);
    this.library.setMediaFavStatus(uuid,favStatus);
  }
}

const authCondition = (authUser) => !!authUser;

var enhance = util.flowRight(
  withAuthorization(authCondition),
  withStyles(styles),
  withWidth()
);

export default enhance(Home);


// WEBPACK FOOTER //
// ./src/CaazamApp/Home.js